export const WIDGET_SCRIPT = process.env.VUE_APP_WIDGET_SCRIPT || 'http://localhost:8082/js/app.js';
export const API_URL = process.env.VUE_APP_DEV_API || 'http://localhost:8080/api/';
